import type { UserStateResponse } from "client/types";
import { apiClient } from "client/utils/api-client";

export const logout = async (): Promise<any> => await fetch("/logout");

export const login = (email: string): Promise<UserStateResponse> =>
  apiClient<UserStateResponse>("/check-email", {
    data: {
      email: email.toLowerCase(),
    },
  });
